export default {"src":"/_next/static/media/c12.511637fa.svg","height":62,"width":162};